// Navigation Actions
export const SHOW_SIDEBAR_MENU = 'SHOW_SIDEBAR_MENU';
export const HIDE_SIDEBAR_MENU = 'HIDE_SIDEBAR_MENU';
export const SET_USER = 'SET_USER';
export const SET_USER_COPY = 'SET_USER_COPY';
export const SET_USER_ARRAY = 'SET_USER_ARRAY';

export const SET_WRITE_DATA = 'SET_WRITE_DATA';
export const SET_HAS_HEADER_RECEIVED = 'SET_HAS_HEADER_RECEIVED';
export const SET_PPID = 'SET_PPID';
export const SET_HAS_APP_RECEIVED = 'SET_HAS_APP_RECEIVED';
export const SET_HEADER_VALUES = 'SET_HEADER_VALUES';
export const SET_MODEL = 'SET_MODEL';
export const SET_ELECTRON_APP = 'SET_ELECTRON_APP';

//^ SOFC_HMI add_header
export const SET_OPERATE_VER = 'SET_OPERATE_VER';
export const SET_SAME_MENU_ITEM_CLICK = 'SET_SAME_MENU_ITEM_CLICK';
export const SET_CURRENT_PLC = 'SET_CURRENT_PLC';

// @ TEST USER Credentials
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_CHECK_SESSION = 'SET_CHECK_SESSION';

// update 240927, HMI Integrated version
export const SET_SOFC_CONFIG = 'SET_SOFC_CONFIG';

// [UPDATE] BUGFIX display alarm label 250813
export const SET_IS_ALARM_SET_MAIN = 'SET_IS_ALARM_SET_MAIN';
export const SET_IS_ALARM_SET_PSM1 = 'SET_IS_ALARM_SET_PSM1';
export const SET_IS_ALARM_SET_PSM2 = 'SET_IS_ALARM_SET_PSM2';
export const SET_IS_ALARM_SET_PSM3 = 'SET_IS_ALARM_SET_PSM3';
export const SET_IS_ALARM_SET_PSM4 = 'SET_IS_ALARM_SET_PSM4';
export const SET_IS_ALARM_SET_PSM5 = 'SET_IS_ALARM_SET_PSM5';
export const SET_PREV_ALARM_MAIN = 'SET_PREV_ALARM_MAIN';
export const SET_PREV_ALARM_PSM1 = 'SET_PREV_ALARM_PSM1';
export const SET_PREV_ALARM_PSM2 = 'SET_PREV_ALARM_PSM2';
export const SET_PREV_ALARM_PSM3 = 'SET_PREV_ALARM_PSM3';
export const SET_PREV_ALARM_PSM4 = 'SET_PREV_ALARM_PSM4';
export const SET_PREV_ALARM_PSM5 = 'SET_PREV_ALARM_PSM5';
export const SET_CURR_ALARM_MAIN = 'SET_CURR_ALARM_MAIN';
export const SET_CURR_ALARM_PSM1 = 'SET_CURR_ALARM_PSM1';
export const SET_CURR_ALARM_PSM2 = 'SET_CURR_ALARM_PSM2';
export const SET_CURR_ALARM_PSM3 = 'SET_CURR_ALARM_PSM3';
export const SET_CURR_ALARM_PSM4 = 'SET_CURR_ALARM_PSM4';
export const SET_CURR_ALARM_PSM5 = 'SET_CURR_ALARM_PSM5';

//Fleet Actions
export const SET_FLEET = 'SET_FLEET';

// [UPDATE] Shutdown ack
export const SET_IS_WARNING_AL = 'SET_IS_WARNING_AL';
export const SET_IS_MUTE = 'SET_IS_MUTE';

// [UPDATE] TE900C Enable 260105
export const SET_TE900C_ENABLE_PSM1 = 'SET_TE900C_ENABLE_PSM1';
export const SET_TE900C_ENABLE_PSM2 = 'SET_TE900C_ENABLE_PSM2';
export const SET_TE900C_ENABLE_PSM3 = 'SET_TE900C_ENABLE_PSM3';
export const SET_TE900C_ENABLE_PSM4 = 'SET_TE900C_ENABLE_PSM4';
export const SET_TE900C_ENABLE_PSM5 = 'SET_TE900C_ENABLE_PSM5';
